import React from 'react';
import { components } from 'react-select';

export const OptionBasic = (props) => {
    return (props.data.isActive !== false && <components.Option {...props} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{props.data.label}</span>
        </div>
        </ components.Option >
  )};

export const OptionCustomer = (props) => {
    const description = `${props.data.isCustomer ? '/ Customer' : ''}${props.data.isEmployee ? ' / Employee' : ''}${props.data.isSuperfund ? ' / Superfund' : ''}${props.data.isSupplier ? ' / Supplier' : ''}${props.data.isOther ? ' / Other' : ''}`;
    return (
        props.data.isActive !== false && <components.Option {...props} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{props.data.label}</span>
            <span style={{ color: '#999', paddingRight: '4px' }}>{description.substring(2)}</span>
        </div>
        </ components.Option >
  )};

export const OptionAccountR1 = (props) => {
    const accType = ['Unknown','Income','Expense','Current asset','Other current liability','Equity','Other income','Other expense','Cost of goods sold','Bank','Accounts receivable','Fixed asset','Other non-current asset','Credit card','Accounts payable','Non-current liability'];
    return (
        props.data.isActive !== false && <components.Option {...props} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{props.data.label}</span>
            <span style={{ color: '#999' }}>
                {(props.data.isMatch || props.data.value.length > 10) ? '' : `${props.data.value} / `}
                {(props.data.RAHAccountType) || (props.data.accountType ? accType[props.data.accountType] : '')}
            </span>
        </div>
        </ components.Option >
  )};


  export const OptionAccount = (props) => (
    props.data.isActive !== false && <components.Option {...props} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{props.data.label}</span>
            <span style={{ color: '#999' }}>
                {(props.data.isMatch || props.data.value.length > 10) ? '' : props.data.value}
            </span>
        </div>
        </ components.Option >
  );

  export const OptionGst = (props) => (
    props.data.isActive !== false && <components.Option {...props} >
        {props.data.label}
        </ components.Option >
  );


// WEBPACK FOOTER //
// ./src/components/UI/select.js